import { client } from './client';

// --- Services (nested under supplier) ---

export const getServicesBySupplier = async (supplierUid) => {
    const response = await client.get(`/v1/suppliers/${supplierUid}/services`);
    return response.data?.items ?? response.data;
};

export const getServices = async () => {
    const response = await client.get('/v1/services');
    return response.data?.items ?? response.data;
};

export const createService = async (supplierUid, data) => {
    const response = await client.post(`/v1/suppliers/${supplierUid}/services`, data);
    return response.data;
};

export const updateService = async (serviceUid, data) => {
    const response = await client.put(`/v1/services/${serviceUid}`, data);
    return response.data;
};

export const deleteService = async (serviceUid) => {
    const response = await client.delete(`/v1/services/${serviceUid}`);
    return response.data;
};

// --- Service Overview ---

/**
 * Returns monthly invoice summaries for the last 12 months for a given service.
 * @param {string} serviceUid - The UID of the service
 * @returns {Promise<Array<{ month: string, count: number, total_amount: number, paid_count: number, unpaid_count: number }>>}
 */
export const getServiceOverview = async (serviceUid) => {
    const response = await client.get(`/v1/services/${serviceUid}/overview`);
    return response.data;
};
